module.exports = __webpack_public_path__ + "img/sanfen.c514e40e.jpg";